module.exports = __webpack_public_path__ + "img/landos-advice__img.png?77e263ac84f614974add79552c4ab579";